import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37163ebb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=37163ebb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37163ebb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37163ebb')) {
      api.createRecord('37163ebb', component.options)
    } else {
      api.reload('37163ebb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=37163ebb&scoped=true", function () {
      api.rerender('37163ebb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/ruleSettings/index.vue"
export default component.exports